
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import InvoiceFormHeader from './InvoiceFormHeader';
import InvoiceFormContent from './InvoiceFormContent';

interface InvoiceFormWrapperProps {
  estimateId: string | null;
  isLoadingEstimate: boolean;
  estimate: any;
  children?: React.ReactNode;
}

const InvoiceFormWrapper: React.FC<InvoiceFormWrapperProps> = ({
  estimateId,
  isLoadingEstimate,
  estimate,
  children
}) => {
  if (!estimateId) {
    return (
      <Card className="max-w-4xl mx-auto">
        <CardContent className="p-6">
          <p className="text-destructive">No estimate ID provided. Please select an estimate to create an invoice.</p>
          <Button asChild className="mt-4">
            <Link to="/estimates">Back to Estimates</Link>
          </Button>
        </CardContent>
      </Card>
    );
  }

  if (isLoadingEstimate) {
    return (
      <Card className="max-w-4xl mx-auto">
        <CardContent className="p-6">
          <p>Loading estimate data...</p>
        </CardContent>
      </Card>
    );
  }

  if (!estimate) {
    return (
      <Card className="max-w-4xl mx-auto">
        <CardContent className="p-6">
          <p className="text-destructive">Estimate not found.</p>
          <Button asChild className="mt-4">
            <Link to="/estimates">Back to Estimates</Link>
          </Button>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <InvoiceFormHeader
        estimateId={estimateId}
        estimateNumber={estimate.estimate_number}
        estimateTitle={estimate.title}
      />
      <CardContent>
        {children}
      </CardContent>
    </Card>
  );
};

export default InvoiceFormWrapper;
